import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import { environment } from '../../../environments/environment';

import swal from 'sweetalert2';
import { UiService } from '../ui/ui.service';
import { UserService } from '../user/user.service';
import { of } from 'rxjs/observable/of';
import { Router } from '@angular/router';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

    private _reqs = [];
    private _authMeCalled = false;

    constructor(
        private ui: UiService,
        private userService: UserService,
        private router: Router
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = localStorage.getItem('access_token');

        const contentType = req.headers.get('Content-Type') || 'application/json';
        let headers = req.headers;

        if (!headers.get('no-content-type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const noErrorHandling = !!headers.get('no-error-handling');

        if (token) {
            headers = headers.set('Authorization', 'Bearer ' + token);
        }

        const url = req.url.includes('auth') || req.url.startsWith('/bmi-')
            ? req.url
            : '/bmi-admin' + req.url;

        const noAppend = req.headers.get('no-append');
        req = req.clone({
            headers,
            url: noAppend ? url : environment.apiUrl + '/api' + url
        });

        // if (this._authMeCalled) {
        //     const subject = new Subject<HttpEvent<any>>();
        //     this._reqs.push({ req, subject });
        //     return subject.asObservable();
        // } else {
        //     if (req.url.endsWith('/auth/me')) {
        //         this._authMeCalled = true;
        //         return next.handle(req)
        //             .map(data => {
        //                 this._authMeCalled = false;
        //                 if (this._reqs.length) {
        //                     const reqs = this._reqs;
        //                     this._reqs = [];
        //                     reqs.forEach(data => {
        //                         next.handle(data.req)
        //                             .catch(err => this._catchError(err))
        //                             .subscribe(
        //                                 res => data.subject.next(res),
        //                                 err => data.subject.error(err),
        //                                 () => data.subject.complete()
        //                             );
        //                     });
        //                 }
        //                 return data;
        //             })
        //             .catch(err => this._catchError(err));
        //     } else {
        //         return next.handle(req).catch(err => this._catchError(err));
        //     }
        // }

        return next.handle(req)
            .catch(err => this._catchError(err, noErrorHandling));
    }

    private _catchError(err, noErrorHandling) {
        const errorObj = {};
        if (err instanceof HttpErrorResponse) {
            if (err.status === 403) {
                localStorage.clear();
                swal(err.error.errmsg, '', 'warning');
                this.router.navigate(['login']);
            } else if (err.status === 401 && err.error.message && err.error.message.toLowerCase().includes('token')) {
                this.userService.info = null;
                localStorage.removeItem('access_token');
                this.router.navigate(['login']);
                setTimeout(() => {
                    this.ui.loader.reset();
                }, 2000);
                swal('Unauthorized', '', 'error');
                return Observable.throw(null);
            }
            console.log(err);
            const error = err.error;
            if (noErrorHandling) {
                return Observable.throw(err.error);
            } else if (error.status_code >= 500) {
                swal('Oops!', 'Something went wrong', 'error');
                // this.ui.loader.reset();
            } else if (error.message) {
                if (localStorage.getItem('jwt-logout')) {
                    localStorage.removeItem('jwt-logout');
                } else {
                    swal('Oops!', error.message, 'error');
                }
            } else if (error.errmsg) {
                const msg = error.errmsg;
                if (typeof msg === 'string') {
                    swal('Warning', msg, 'warning');
                } else {
                    Object.keys(msg).forEach(key => {
                        errorObj[key] = msg[key][0];
                    });
                }
            } else if (error.error) {
                const msg = error.error;
                if (typeof msg === 'string') {
                    swal('Warning', msg, 'warning');
                } else {
                    Object.keys(msg).forEach(key => {
                        errorObj[key] = msg[key][0];
                    });
                }
            } else {
                swal('Oops!', 'Something went wrong', 'error');
            }
        }
        return Observable.throw(errorObj);
    }
}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/services/api-interceptor/api-interceptor.ts